import { render, staticRenderFns } from "./SalesExportDetails.vue?vue&type=template&id=a90b59b6&"
import script from "./SalesExportDetails.vue?vue&type=script&lang=js&"
export * from "./SalesExportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports